import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, ImageUploadWithPreview } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { IoIosClose } from 'react-icons/io';
import { fetchDetails } from 'src/redux/action/details.action';
import Loader from 'src/components/loader';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import MapContainer from 'src/components/Map';

interface IProps {
  address?: any;
  loading?: boolean;
}

const FORM_VALIDATION = Yup.object().shape({
  primaryContactNumber: Yup.string()
    .matches(
      /(?:\(?\+977\)?)?[9][6-9]\d{8}|01[-]?[0-9]{7}/,
      'Invalid Nepali phone number'
    )
    .min(9, 'Primary Contact Number must be at least 9 characters')
    .max(10, 'Primary Contact Number must be at most 10 characters')
    .nullable(),
  secondaryContactNumber: Yup.string()
    .matches(
      /(?:\(?\+977\)?)?[9][6-9]\d{8}|01[-]?[0-9]{7}/,
      'Invalid Nepali phone number'
    )
    .min(9, 'Secondary Contact Number must be at least 9 characters')
    .max(10, 'Secondary Contact Number must be at most 10 characters')
    .nullable()
    .test(
      'not-equal',
      'Secondary contact number should not be the same as primary',
      function (value) {
        const primaryContactNumber = this.resolve(
          Yup.ref('primaryContactNumber')
        );
        return value !== primaryContactNumber;
      }
    ),
  email: Yup.string().email('Invalid email address').nullable(),
});

const Address: React.FC<IProps> = ({ address, loading }) => {
  // const [lnglat, setLngLat] = useState<any>([0, 0]);
  // const [map, setMap] = useState<any>(null);
  // const [marker, setMarker] = useState<any>(null);
  const [latitude, setLatitude] = useState<any>(
    address?.address?.coordinates?.latitude
  );
  const [longitude, setLongitude] = useState<any>(
    address?.address?.coordinates?.longitude
  );
  const dispatch = useDispatch();
  // useEffect(() => {
  //   setLatitude(address?.address?.coordinates?.latitude);
  //   setLongitude(address?.address?.coordinates?.longitude);
  // }, [address?.address]);

  const initValues = {
    area: address ? address?.address?.area : '',
    city: address ? address?.address?.city : '',
    primaryContactNumber: address ? address?.contactDetails?.primaryPhone : '',
    secondaryContactNumber: address
      ? address?.contactDetails?.secondaryPhone
      : '',
    email: address ? address?.contactDetails?.primaryEmail : '',
    latitude: address ? address?.adress?.coordinates?.latitude : '',
    longitude: address ? address?.adress?.coordinates?.longitude : '',
  };

  // useEffect(() => {
  //   const mapContainer = document.getElementById('map');
  //   if (!mapContainer) {
  //     return;
  //   }
  //   if (typeof latitude !== 'number' || typeof longitude !== 'number') {
  //     return;
  //   }

  //   mapboxgl.accessToken =
  //     'pk.eyJ1Ijoibm92dXMtZnNpbmMiLCJhIjoiY2xvZHYycmlzMDJ2ZTJpazFpZGpjc3NubiJ9.NZZAjphfCX4XzMRsHjG9_Q';

  //   const map = new mapboxgl.Map({
  //     container: 'map',
  //     style: 'mapbox://styles/mapbox/streets-v11',
  //     center: [longitude, latitude],
  //     zoom: 15,
  //   });

  //   map.on('load', function () {
  //     map.flyTo({
  //       center: [longitude, latitude],
  //       essential: true,
  //     });
  //   });

  //   const markerData = new mapboxgl.Marker({
  //     draggable: true,
  //   })
  //     .setLngLat([longitude, latitude]) // Use provided latitude and longitude
  //     .addTo(map);

  //   markerData.on('dragend', function () {
  //     var lngLat = markerData.getLngLat();
  //     setLatitude(lngLat.lat);
  //     setLongitude(lngLat.lng);
  //   });

  //   setMarker(markerData);
  //   setMap(map);

  //   const geocoder = new MapboxGeocoder({
  //     // accessToken:'pk.eyJ1Ijoibm92dXMtZnNpbmMiLCJhIjoiY2xvZHYycmlzMDJ2ZTJpazFpZGpjc3NubiJ9.NZZAjphfCX4XzMRsHjG9_Q',
  //     accessToken: mapboxgl.accessToken,
  //     mapboxgl: mapboxgl,
  //   });

  //   map.addControl(geocoder);

  //   geocoder.on('result', function (e) {
  //     markerData.setLngLat(e.result.geometry.coordinates);
  //     setLatitude(e.result.geometry.coordinates[1]);
  //     setLongitude(e.result.geometry.coordinates[0]);
  //   });
  // }, [latitude, longitude]);

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const payload = {
      address: {
        city: values?.city,
        area: values?.area,
        coordinates: {
          latitude: latitude,
          longitude: longitude,
        },
      },
      contactDetails: {
        primaryPhone: values?.primaryContactNumber,
        secondaryPhone: values?.secondaryContactNumber,
        primaryEmail: values?.email,
      },
    };
    try {
      await Service.post('/settings/update', payload);
      toastAlert('success', `Address is successfully updated`);
      dispatch(fetchDetails() as any);
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initValues}
          validateOnMount
          onSubmit={handleSubmit}
          validationSchema={FORM_VALIDATION}
        >
          {({ isSubmitting, isValid }) => (
            <Form>
              {/* <div className="relative"></div> */}
              <TextField label={'Area'} name="area" />
              <TextField label={'City'} name="city" />

              {/* uncomment this when order within certain radius is needed  */}

              {/* <MapContainer
                showMarker={true}
                address={address}
                radius={0}
                latitude={latitude}
                setLatitude={setLatitude}
                longitude={longitude}
                setLongitude={setLongitude}
              /> */}
              <TextField
                label={'Primary Contact Number'}
                name="primaryContactNumber"
                type="tel"
              />
              <TextField
                label={'Secondary  Contact Number'}
                name="secondaryContactNumber"
                type="tel"
              />
              <TextField label={'Email'} name="email" />
              <div className="flex items-center justify-end my-2">
                <Button
                  text="save details"
                  variant="primary"
                  type="submit"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default React.memo(Address);
